import type { TabsProps } from "antd";
import { create, createStore, type StateCreator } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

export interface TabsStore {
  tabs: TabsProps["items"];
  setTabs(tabs: TabsProps["items"]): void;
  activeKey?: string;
  setActiveKey(activeKey: string): void;
  reset(): void;
}

const tabsStoreCreator: StateCreator<TabsStore> = (set, get) => ({
  tabs: [],
  activeKey: "1",
  setTabs: (tabs) => set({ tabs }),
  setActiveKey: (activeKey: string) => {
    set({ activeKey });
  },
  reset: () => {
    set({ tabs: [], activeKey: "1" });
  },
});

export const useTabsStore = create<TabsStore>()(
  devtools(
    persist(tabsStoreCreator, {
      name: "tabs-storage",
      storage: createJSONStorage(() => sessionStorage),
    })
  )
);
export const tabsStore = createStore<TabsStore>(tabsStoreCreator);
